export const RECORD_TO_FETCH = 1000;
export const EPISODE_ROUND_COUNT = 9;
